<IziPage class="hall-container">
  <IziGrid>
    <IziCol xl="3" lg="3" md="4" class="left-hall">
      <LeftHall />
    </IziCol>
    <IziCol xl="6" lg="6" md="4" class="list-game">
      <span v-show="games.length === 0">Not Found</span>
      <ListGame :games="games"></ListGame>
    </IziCol>
    <IziCol xl="3" lg="3" md="4" class="right-hall">
      <RightHall />
    </IziCol>
  </IziGrid>
</IziPage>
